/**
 * Git repository tracking.
 * Repos are identified by a canonical external URL; multiple sessions, threads,
 * and bridges can be associated with a single repo.
 */

import { z } from 'zod';

export const GitRepoMetaSchema = z.object({
  /** Stable id for the repo (e.g. hash of normalized canonical URL). Used for DO idFromName. */
  repoId: z.string(),
  /** Canonical external URL (e.g. https://github.com/org/repo). Normalize before storing. */
  canonicalUrl: z.string().url(),
  /** Optional workspace this repo was first linked in. */
  workspaceId: z.string().nullable(),
  displayName: z.string().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type GitRepoMeta = z.infer<typeof GitRepoMetaSchema>;
